<template>
<div class="cookie-monster-component">
  <cookie-banner
    v-if="showBanner"
    @onAcceptAll="onAcceptAll"
    @onManageConsent="onManageConsent"
  ></cookie-banner>
  <!--
    Authenticated users will use the cookie settings page, and
    should not see the cookie consent FAB
  -->
  <cookie-button
    v-if="!isLoggedIn && showButton"
    @onManageConsent="onManageConsent"
  ></cookie-button>
  <cookie-modal
    :show="showModal"
    @onSetConsent="onSetConsent"
    @onDeclineAll="onDeclineAll"
  ></cookie-modal>
</div>
</template>

<script>
import cookieService from '../services/cookieService';
import CookieBanner from './CookieBanner';
import CookieButton from './CookieButton';
import CookieModal from './CookieModal';

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CookieBanner,
    CookieButton,
    CookieModal
  },
  data() {
    return {
      showBanner: false,
      showButton: false,
      showModal: false
    };
  },
  methods: {
    onManageConsent() {
      this.showBanner = false;
      this.showButton = true;
      this.showModal = true;
    },
    onAcceptAll() {
      cookieService.getAcceptAll();

      this.showBanner = false;
      this.showButton = true;
    },
    onSetConsent(consent) {
      cookieService.setConsent(consent);
      this.showModal = false;
    },
    onDeclineAll() {
      cookieService.getDeclineAll();
      this.showModal = false;
    },
  },
  mounted() {
    cookieService.manageLegacyConsent();

    if (!cookieService.getConsent()) {
      this.showBanner = true;
    } else {
      this.showButton = true;
    }
  },
};
</script>

<style scoped lang="scss"></style>
